<script setup>
const config = useRuntimeConfig()
const router = useRouter()
const hostDomain = config.public.hostDomain

const error = useError()
const statusCode = error.value.statusCode
const { $errorCodeList } = useNuxtApp()
const errorData = $errorCodeList

const errorTitle = computed(() => errorData[statusCode]?.title || errorData.default.title)
const errorMessage = computed(() => errorData[statusCode]?.message || errorData.default.message)
const errorIcon = computed(() => errorData[statusCode]?.icon || errorData.default.icon)

const isIgnored404 = statusCode === 404
  && (
    error.value?.message === 'River System Page Not Found'
    || error.value?.message === 'Invalid Query Parameter'
    || error.value?.message?.startsWith('Page not found:')
  )

if (!isIgnored404) {
  console.error(error.value)
}
onMounted(async () => {
  await router.push('/')
})
</script>

<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">
        <span>{{ errorIcon }}</span>
      </div>
      <h1>{{ errorTitle }}</h1>
      <p>{{ errorMessage }}</p>
      <a
        :href="`${hostDomain}/onebox/river/`"
        class="back-button"
      >
        トップページに戻る
      </a>
    </div>
  </div>
</template>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #fff;
}

.error-content {
  text-align: center;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.error-icon {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #777777;
  text-align: left;
}

h1 {
  margin-bottom: 1rem;
  font-weight: 700;
  text-align: left;
}

p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  background-color: #fff;
  color: #2196f3;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  font-weight: 500;
}

.back-button:hover {
  background-color: #2196f3;
  color: #fff;
}
</style>
